export interface PageInfoLike {
  readonly hasNextPage?: boolean | null
  readonly endCursor?: string | null
}

interface LibraryPage {
  readonly user?: {
    readonly libraryV2?: {
      readonly pageInfo?: PageInfoLike | null
    } | null
  } | null
}

/**
 * The cursor for the next page, or undefined when the list is exhausted.
 * Returning undefined is what tells TanStack Query there is no next page.
 */
export const nextLibraryCursor = (page: LibraryPage): string | undefined => {
  const pageInfo = page.user?.libraryV2?.pageInfo

  if (!pageInfo?.hasNextPage) {
    return undefined
  }

  return pageInfo.endCursor ?? undefined
}
